module.exports = __webpack_public_path__ + "static/media/archive1.0f6ab1e7.jpeg";